import a from "react";
import { getIconColor as m } from "./iconfont.es5470.js";
import h from "./iconfont.es5471.js";
const r = {
  display: "block"
}, Z = ({ size: e = 16, useVw: c, useRem: t, color: n, withColor: o, removeClassName: l, disableSSR: i, style: d, ...v }) => {
  const p = d ? { ...r, ...d } : r;
  return /* @__PURE__ */ a.createElement(h, { disableSSR: i }, /* @__PURE__ */ a.createElement("svg", { "data-icon-id": "32px-100baozhengjin", "data-icon-group": "GateHeader", "data-icon-version": "0.8.1", viewBox: "0 0 32 32", width: c ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (t ? "rem" : "px"), height: c ? ((e || 0) / 375 * 100).toFixed(5) + "vw" : e + (t ? "rem" : "px"), className: l ? "" : "iconpark-icon", style: p, fill: "none", ...v }, /* @__PURE__ */ a.createElement(
    "g",
    {
      className: l ? "" : "32px-100%ä¿è¯é"
    },
    /* @__PURE__ */ a.createElement(
      "g",
      {
        className: l ? "" : "normal",
        fill: o ? m(n, 0, "#0B0C0D") : "#0B0C0D",
        datafollowfill: o ? m(n, 0, "#0B0C0D") : "#0B0C0D"
      },
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "m7.22 8.213 6.752-2.764a5.386 5.386 0 0 1 4.057 0l6.748 2.762c.26.107.552.347.781.687.23.339.342.696.343.974v.001l-.012 5.317v.002a11.8 11.8 0 0 1-.552 3.538.9.9 0 1 0 1.718.54c.411-1.31.633-2.682.634-4.077v-.001l.012-5.317v-.002c0-.715-.269-1.417-.651-1.983-.383-.566-.934-1.076-1.593-1.345L18.71 3.783h-.001a7.184 7.184 0 0 0-5.417 0L6.546 6.544c-.667.27-1.219.78-1.6 1.348-.382.568-.645 1.27-.645 1.981v5.319a13.6 13.6 0 0 0 .634 4.078.9.9 0 0 0 1.717-.54 11.799 11.799 0 0 1-.551-3.538V9.873c0-.281.112-.64.339-.977.226-.337.516-.577.78-.683Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "m21.542 11.969-6 5.625a.9.9 0 0 1-1.23 0l-3-2.813a.9.9 0 0 1 1.23-1.313l2.385 2.236 5.384-5.048a.9.9 0 0 1 1.231 1.313ZM7.479 21.325a.7.7 0 0 1 .421.642v5.6a.7.7 0 1 1-1.4 0v-3.99l-.822.768a.7.7 0 1 1-.956-1.023l2-1.867a.7.7 0 0 1 .757-.13Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M9 23.467a2.2 2.2 0 0 1 4.4 0v2.6a2.2 2.2 0 0 1-4.4 0v-2.6Zm2.2-.8a.8.8 0 0 0-.8.8v2.6a.8.8 0 0 0 1.6 0v-2.6a.8.8 0 0 0-.8-.8Zm5.5-1.4a2.2 2.2 0 0 0-2.2 2.2v2.6a2.2 2.2 0 0 0 4.4 0v-2.6a2.2 2.2 0 0 0-2.2-2.2Zm-.8 2.2a.8.8 0 0 1 1.6 0v2.6a.8.8 0 0 1-1.6 0v-2.6Zm5.374-2.067c-.317 0-.605.08-.861.242a1.577 1.577 0 0 0-.6.666c-.144.288-.213.633-.213 1.03 0 .396.07.744.213 1.038a1.577 1.577 0 0 0 1.46.899 1.566 1.566 0 0 0 1.461-.908c.15-.295.222-.639.222-1.03 0-.396-.072-.741-.221-1.03a1.577 1.577 0 0 0-.6-.665 1.557 1.557 0 0 0-.861-.242Zm.009.9c-.186 0-.34.094-.46.259v.002c-.118.171-.168.437-.168.776 0 .34.05.605.167.777l.002.002c.12.164.273.259.459.259s.335-.096.443-.263c.117-.17.167-.436.167-.775 0-.338-.05-.604-.167-.775-.108-.167-.257-.262-.443-.262Z",
          fillRule: "evenodd"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          d: "M25.208 21.485a.635.635 0 0 0-.536.295l-3.525 5.56a.635.635 0 0 0 1.072.68l3.525-5.56a.635.635 0 0 0-.536-.975Z"
        }
      ),
      /* @__PURE__ */ a.createElement(
        "path",
        {
          clipRule: "evenodd",
          d: "M25.617 24.525a1.591 1.591 0 0 0-1.46.908c-.144.289-.213.633-.213 1.03 0 .396.07.744.212 1.038.142.287.34.51.591.666h.001c.257.156.548.233.87.233a1.577 1.577 0 0 0 1.461-.898c.148-.295.221-.642.221-1.04 0-.396-.072-.74-.222-1.03a1.578 1.578 0 0 0-.599-.664 1.558 1.558 0 0 0-.862-.243Zm0 .9c-.181 0-.331.096-.45.259l-.001.002c-.118.171-.167.437-.167.777 0 .339.05.605.167.776l.001.002c.119.163.269.26.45.26.187 0 .338-.096.452-.262.118-.171.167-.437.167-.776 0-.34-.05-.606-.167-.777-.114-.166-.265-.261-.452-.261Z",
          fillRule: "evenodd"
        }
      )
    )
  )));
}, g = Z;
export {
  g as default
};
